import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountingPeriodsReducer } from '../reducers';

export const selectAccountingPeriodsFeature = createFeatureSelector<AccountingPeriodsReducer.AccountingPeriodsState>(AccountingPeriodsReducer.featureName);

export const selectAccountingPeriods = createSelector(selectAccountingPeriodsFeature, (state: AccountingPeriodsReducer.AccountingPeriodsState) => state.item);
